import { render, staticRenderFns } from "./ReportTableWithHeader.vue?vue&type=template&id=df5adf48"
import script from "./ReportTableWithHeader.vue?vue&type=script&lang=js"
export * from "./ReportTableWithHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports